/* eslint-disable @typescript-eslint/indent */

interface ICommonProps {
  label: string;
  text: string;
}

interface IFieldTextVariant extends ICommonProps {
  type: 'default';
}

/**
 * TODO: Get the currency from the active user from useAuth.
 * @deprecated - This type is not required at all.
 */
interface IFieldCurrencyVariant extends ICommonProps {
  currency: string; // TODO: Will get this from actively user login
  type: 'currency';
}

export interface IFieldDescriptionVariant extends Omit<ICommonProps, 'label'> {
  label?: string;
  type: 'description';
}

export interface IFieldEmpty {
  type: 'empty';
}

export interface IFieldProps {
  variant:
    | IFieldCurrencyVariant
    | IFieldDescriptionVariant
    | IFieldEmpty
    | IFieldTextVariant;
}

export interface IField extends IFieldProps {
  id: string;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a field with a label and text and currency name
 */
export function Field({ variant }: Readonly<IFieldProps>) {
  const { type } = variant;

  if (type === 'empty') return <div className="hidden sm:block" />;

  const { label, text } = variant;
  const isCurrency = type === 'currency';

  return (
    <div className="flex flex-col gap-x-2 gap-y-1 text-xs sm:flex-row">
      {label ? <div className="text-gray-400">{label}</div> : null}

      {isCurrency ? (
        <div className="flex gap-1">
          <div className="font-medium text-green-800">{variant.currency}</div>
          <div className="font-bold text-green-600">{text}</div>
        </div>
      ) : (
        <div className="text-gray-600">{text}</div>
      )}
    </div>
  );
}
